<script setup lang="ts">

import DropdownComponent from './dropdown/DropdownComponent.vue';
import DropdownTrigger from './dropdown/DropdownTrigger.vue';
import DropdownBody from './dropdown/DropdownBody.vue';
import Option from "./BaseOption.vue"

import { Button } from '@albank/vue-ui-kit';
import { inject } from 'vue';

const view = inject("view", "mobile")
const options = [
  {
    icon: {
      src: "/assets/icons/percent.svg",
      alt: "Кредит"
    },
    heading: "Кредит на любые цели",
    text: "Сумма до 3 млн ₽",
    link: "https://albank.ru/ru/credits/simple-credit/"
  },
  {
    icon: {
      src: "/assets/icons/pig.svg",
      alt: "Вклад"
    },
    heading: "Откройте вклад",
    text: "Со сроком от 2 месяцев",
    link: "https://albank.ru/ru/deposits/"
  },
  {
    icon: {
      src: "/assets/icons/personal-card.svg",
      alt: "Карта"
    },
    heading: "Карта жителя Якутии",
    text: "Социальные выплаты, льготные услуги",
    link: "https://albank.ru/ru/cards/ecs-card/"
  },
]
</script>

<template>
  <header class="header">
    <a 
      href="https://albank.ru" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <img src="/assets/logo.svg" alt="AEB" />
    </a>
    <nav>
      <DropdownComponent v-if="view != 'mobile'" class="become-client">
        <DropdownTrigger>
          <Button
            :icon-source="{left: '/assets/icons/flash-on.svg'}"
            variant="secondary" class="button secondary-button"
          >Стать клиентом</Button>  
        </DropdownTrigger>
        <DropdownBody
:style="{
          top: '60px', bottom: 'auto', 
          alignItems: 'start', gap: '24px'
        }">
          <label class="dropdown-label">СТАТЬ КЛИЕНТОМ АЭБ</label>
          <Option 
            v-for="option in options" 
            v-bind="option"
            :key="option.heading"
          />
        </DropdownBody>
      </DropdownComponent>

      <a href="https://online.albank.ru/">
        <Button 
          class="button"
          :class="view == 'mobile'? 'secondary-button': ''"
        >Интернет-банк</Button>
      </a>
    </nav>
  </header>
</template>

<style lang="scss">
.header {
  width: 100%;
  height: 84px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  nav {
    gap: 20px;
    display: flex;
  }

  @media screen and (min-width: 1200px) {
    max-width: 1140px;
  }

  @media screen and (max-width: 1200px) {
    padding: 12px 10%;
  }

  @media screen and (max-width: 767px) {
    padding: 10px 16px;
  }
}


.dropdown-label {
  font-weight: var(--font-weight-medium);
  color: var(--color-mono-400);
}

.become-client {
  @media screen and (max-width: 767px) {
    display: none;
  }
}
</style>
